import axios from "axios";
import Axios from "axios";

export const authAxios = () => {
  const token = JSON.parse(sessionStorage.getItem("newToken") || "");
  return Axios.create({
    baseURL:
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEV_URL
        : process.env.REACT_APP_PRO_URL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
const axiosClient = axios.create();

axiosClient.defaults.baseURL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_DEV_URL
    : process.env.REACT_APP_PRO_URL;

//default axios timeout 
axiosClient.defaults.timeout = 5*60*1000;

axiosClient.defaults.withCredentials = false;

export async function getRequest(URL: String) {
  const token = JSON.parse(sessionStorage.getItem("newToken") || "");
  axiosClient.defaults.headers.common = { Authorization: `Bearer ${token}` };
  return await axiosClient.get(`/${URL}`);
}

export async function postRequest(URL: String, payload: Object) {
  if (URL !== "login" && URL !== "forgetPassword") {
    const token = JSON.parse(sessionStorage.getItem("newToken") || "");
    axiosClient.defaults.headers.common = { Authorization: `Bearer ${token}` };
    return await axiosClient.post(`/${URL}`, payload);
  } else {
    return await axiosClient.post(`/${URL}`, payload);
  }
}

export async function putRequest(URL: String, payload: Object) {
  const token = JSON.parse(sessionStorage.getItem("newToken") || "");
  axiosClient.defaults.headers.common = { Authorization: `Bearer ${token}` };
  return await axiosClient.put(`/${URL}`, payload);
}

export async function patchRequest(URL: String, payload: Object) {
  const token = JSON.parse(sessionStorage.getItem("newToken") || "");
  axiosClient.defaults.headers.common = { Authorization: `Bearer ${token}` };
  return await axiosClient.patch(`/${URL}`, payload);
}

export async function deleteRequest(URL: String) {
  const token = JSON.parse(sessionStorage.getItem("newToken") || "");
  axiosClient.defaults.headers.common = { Authorization: `Bearer ${token}` };
  return await axiosClient.delete(`/${URL}`);
}
